import { Empty, VideoLineIcon } from 'ui';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports -- TODO: break circular dependency
import { EntityList } from 'features/channels/components';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports -- TODO: fix according to result of #67489
import { useVideosInfiniteQuery } from 'features/videos/queries';

type P = {
  getPathToVideoDetail: (id: string) => string;
  organizationId: string;
};

const OrganizationsVideosList = ({ getPathToVideoDetail, organizationId }: P) => {
  const {
    data: allVideosData,
    fetchNextPage,
    hasNextPage,
    isFetching: isFetchingAll,
    isLoading: isLoadingAll,
  } = useVideosInfiniteQuery({
    filter: { organizationId },
    pagination: { pageSize: 12 },
  });

  const allVideos = allVideosData?.pages.flat().flatMap((videosPaginated) => videosPaginated.data);

  return (
    <EntityList
      empty={
        <Empty
          description={{
            subtitle: 'There are no videos to display here',
            title: 'No videos',
          }}
          image={<VideoLineIcon />}
        />
      }
      entities={allVideos?.map((video) => ({
        data: video,
        type: 'Video',
      }))}
      fetchNextPage={fetchNextPage}
      getPathToEntityDetail={getPathToVideoDetail}
      hasNextPage={hasNextPage}
      isFetching={isFetchingAll}
      isLoading={isLoadingAll}
    />
  );
};

export default OrganizationsVideosList;
